import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';

@Injectable()
export class ForceHTTPSGuard implements CanActivate {

  private devMode: boolean;

  constructor(
    private router: Router
  ) {
    this.devMode = false;
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // basically always default to https mode unless the environment variable
    // is set to not be, and we are in dev mode using localhost as the root.
    // This is because localhost cannot use https without generating a local certificate
    // and registering it which is a hassle. On the flip side, all web API calls
    // need to allow a non-https connection from localhot through CORS as well.
    if (environment.FORCEHTTPS) {
      if (location.protocol !== 'https:') {
        location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
        return false;
      }

    } else {
      this.devMode = (location.href.indexOf('localhost') >= 0) ? true : false;
      if (location.protocol !== 'https:' && !this.devMode) {
        location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
        return false;
      }
    }
    return true;
  }
}
